export const BankingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8V12.001H3V18H2V21H3H6H8H11H13H16H18L21 21.001V21H22V18H21V12.001H22V8L12 2L2 8ZM6 18V12.001H8V18H6ZM11 18V12.001H13V18H11ZM18 18H16V12.001H18V18ZM14 8C14 9.104 13.104 10 12 10C10.896 10 10 9.104 10 8C10 6.896 10.896 6 12 6C13.104 6 14 6.896 14 8Z"
        fill="#484848"
      />
    </svg>
  );
};
